import {
  DefaultMantineColor,
  createTheme,
  MantineColorsTuple,
} from '@mantine/core';
import {ComponentsThemes} from './components';
import {generateColors} from '@mantine/colors-generator';

export const PrimaryColor = '#355C54';
export const SecondaryColor = '#E3B025';
export const AccentColors = ['#0D666E', '#3A4569'];

export const DefaultThemeColors = {
  primary: generateColors(PrimaryColor),
  secondary: generateColors(SecondaryColor),
  primaryAccent: generateColors(AccentColors[0]),
  secondaryAccent: generateColors(AccentColors[1]),
};

type ExtendedCustomColors = 'secondary' | DefaultMantineColor;

declare module '@mantine/core' {
  export interface MantineThemeColorsOverride {
    colors: Record<ExtendedCustomColors, MantineColorsTuple>;
  }
}

export const DefaultTheme = createTheme({
  fontFamily: 'Inter, sans-serif',
  headings: {
    sizes: {
      h1: {
        fontSize: '17px',
        fontWeight: 'semi-bold',
      },
      h2: {
        fontSize: '15px',
        fontWeight: 'semi-bold',
      },
      h3: {
        fontSize: '13px',
        fontWeight: 'semi-bold',
      },
      h4: {
        fontSize: '11px',
        fontWeight: 'semi-bold',
      },
      h5: {
        fontSize: '9px',
        fontWeight: 'semi-bold',
      },
    },
  },
  fontSizes: {
    xl: '17px',
    l: '15px',
    m: '13px',
    sm: '11px',
    xs: '9px',
  },
  breakpoints: {
    md: '65em',
  },
  primaryColor: 'primary',
  primaryShade: 6,
  defaultRadius: '6px',
  components: ComponentsThemes,
  colors: DefaultThemeColors,
});

export const PrimaryColorCssVar = `var(--mantine-primary-color-filled)`;
export const PrimaryColorHoverCssVar = `var(--mantine-primary-color-filled-hover)`;
export const PrimaryColorLightCssVar = `var(--mantine-primary-color-light)`;
export const PrimaryColorLightHoverCssVar = `var(--mantine-primary-color-light-hover)`;

export const SecondaryColorCssVar = `var(--mantine-color-secondary-6)`;
export const SecondaryColorHoverCssVar = `var(--mantine-color-secondary-8)`;
export const SecondaryColorLightCssVar = `var(--mantine-color-secondary-4`;
export const SecondaryColorLightHoverCssVar = `var(--mantine-color-secondary-2)`;
